import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NGXLogger } from 'ngx-logger';
import { Observable, throwError, TimeoutError, Subject } from 'rxjs';
import { catchError, timeout } from 'rxjs/operators';


@Injectable({
  providedIn: 'root'
})

/**
* This service is created to Consume a PYTHON API and to extract a JSON containing the fields in the image and
* produced by this API from the selected File
 */

export class PythonApiService {
  public cancelled = false;
  protected readonly destroy$ = new Subject<void>();
  private readonly apiUrl = 'https://draw.eazly.com/ganam';
  constructor(private readonly http: HttpClient, private readonly logger: NGXLogger) { }

  /**
       * Method calling the API Rest for uploading a file and getting a JSON response produced by the API.
       *
       * @param selectedFile selectedFile containing the photo selected to extract the JSON
       * @returns A Response object with the Json result extracted from the
      *  given File.
       */

  uploadFileAndGetResponse(selectedFile: File): Observable<any> {
    const formData = new FormData();
    formData.append('file', selectedFile);
    return this.http.post<any>(this.apiUrl, formData).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error instanceof HttpErrorResponse && error.status === 400) {
          this.logger.debug('File upload failed - 400 :', error);
        }
        else if (error.status === 500) {
          this.logger.debug('Error saving file to disk', error);
        }
        return throwError(error);
      }),
    );
  }

  /**
   * Method for cancelling the request of calling the API
   */

  cancelRequest(): void {
    this.cancelled = true;
    this.destroy$.next();
    this.destroy$.complete();
  }
}
